import {ProjectsFilter} from '.'

export const CURRENT_PROJECTS_INITIAL_FILTER: ProjectsFilter = {
  region: [],
  borrower: [],
  manager: [],
  status: [],
  category: [],
}

export const CLOSED_PROJECTS_INITIAL_FILTER: ProjectsFilter = {
  region: [],
  borrower: [],
  manager: [],
  category: [],
}
